import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import user from 'app/common/reducers/user';
import profile from 'app/common/reducers/profile';
import about from 'app/common/reducers/about';
import confirmation from 'app/common/reducers/confirmation';

import { USER_LOGOUT } from 'app/common/actions/user';

import documents from 'app/common/reducers/documents';
import errors from 'app/common/reducers/errors';
import popup from 'app/common/reducers/popup';
import shop from 'app/common/reducers/shop';

import dealer from './dealerReducer';
import students from './studentsReducer';
import passages from './passages';
import schools from './schoolsReducer';
import finances from './finances';
import financeBalance from './financeBalance';

import balance from './cafeteria/balance';
import cafeteriaFinances from './cafeteria/finances';
import costs from './cafeteria/costs';
import sections from './cafeteria/sections';

import polls from './fund/polls';
import poll from './fund/poll';

import apps from './apps';

import settings from './settings';
import assistance from './assistance';

import { events, unread } from './events';
import eljur from './eljur';

import identifiers from './identifiers';


const appReducer = combineReducers({
  routing: routerReducer,
  cafeteria: combineReducers({
    balance,
    finances: cafeteriaFinances,
    costs,
    sections,
  }),
  fund: combineReducers({
    polls,
    poll,
  }),
  events: combineReducers({
    data: events,
    unread,
  }),
  user,
  dealer,
  students,
  passages,
  schools,
  popup,
  apps,
  finances,
  financeBalance,
  settings,
  assistance,
  profile,
  eljur,
  identifiers,
  about,
  confirmation,
  documents,
  errors,
  shop,
});

export default (state, action) => {
  if (action.type === USER_LOGOUT) {
    // При выходе вернуть пустой стор, но информацией о поставщике
    return appReducer({ dealer: state.dealer }, action);
  }

  return appReducer(state, action);
};
